var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.user.is_admin)?_c('div',[_c('Header')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }